// extracted by mini-css-extract-plugin
export default {"infoWrapper":"Home_infoWrapper__RXjE2","start":"Home_start__HydGP","header":"Home_header__fCbNt","container":"Home_container__R-u8z"};